import Spinner from '@rio-cloud/rio-uikit/Spinner';
import { RequireAuth, RequireGuest } from 'features/auth/AuthRoutes';
import { createBrowserRouter, Navigate } from 'react-router';

import AppLayout from '../layout/AppLayout';
import ErrorPage from '../pages/ErrorPage';
import { routes } from './routes';

// Hoisted so these static elements are created once instead of on every render.
const transportOrdersRedirect = <Navigate to={routes.TRANSPORT_ORDERS} replace />;
const hydrateFallback = <Spinner text='Loading' isFullScreen show />;

const archivedRoute = import.meta.env.DEV
    ? [
          {
              path: routes.ARCHIVED,
              lazy: { Component: () => import('../pages/Archived').then(module => module.default) },
          },
      ]
    : [];

export const router = createBrowserRouter([
    {
        Component: RequireAuth,
        children: [
            {
                path: routes.DEFAULT,
                Component: AppLayout,
                // The error page has to render even when a lazily loaded page fails to load.
                ErrorBoundary: ErrorPage,
                hydrateFallbackElement: hydrateFallback,
                children: [
                    { index: true, element: transportOrdersRedirect },
                    {
                        path: routes.TRANSPORT_ORDERS,
                        lazy: { Component: () => import('../pages/TransportOrders').then(module => module.default) },
                    },
                    {
                        path: routes.IN_TRANSIT,
                        lazy: { Component: () => import('../pages/InTransit').then(module => module.default) },
                    },
                    {
                        path: routes.DELIVERED,
                        lazy: { Component: () => import('../pages/Delivered').then(module => module.default) },
                    },
                    ...archivedRoute,
                ],
            },
        ],
    },
    {
        Component: RequireGuest,
        children: [
            {
                path: routes.LOGIN,
                lazy: { Component: () => import('../pages/Login').then(module => module.default) },
                hydrateFallbackElement: hydrateFallback,
            },
        ],
    },
    {
        // Outside the guards: this route is what turns an incomplete sign in into a session.
        path: routes.AUTH_CALLBACK,
        lazy: { Component: () => import('../pages/AuthCallback').then(module => module.default) },
        hydrateFallbackElement: hydrateFallback,
    },
    {
        path: routes.ERROR,
        Component: ErrorPage,
    },
    {
        path: '*',
        Component: ErrorPage,
    },
]);
